<template>
  <div class="modal-overlay">
    <div class="loader"></div>
    <h3 class="loading-text">... đang tải dữ liệu ...</h3>
  </div>
</template>

<script>
export default {
  //
};
</script>

<style scoped>
/* Nền mờ */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Hiệu ứng Loader */
.loader {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top: 5px solid #ffffff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Text Loading */
.loading-text {
  color: white;
  font-size: 18px;
  margin-top: 10px;
}

/* Keyframes cho hiệu ứng quay */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
